<template>
  <div v-if="flag.type === 'usedAI'">
    <div class="d-flex align-items-center">
      <eg-b-icon variant="danger" class="mr-3" icon="flag" />
      <div class="flag-title">{{ $t("essays.aiDetectionResults") }}</div>
    </div>
    <div class="mt-2">
      <div>
        {{ $t("essays.detectorHighlyConfident") }}
        <b>{{ $t("essays.highlyConfident") }}</b> {{ $t("essays.thatTextIs") }}
        <b
          >{{
            flag.summary.aiUsageScore > 50
              ? $t("essays.isWritten")
              : $t("essays.notWritten")
          }}
          {{ $t("essays.writtenByAI") }}</b
        >
        {{ $t("essays.byAI") }}
      </div>
    </div>

    <div class="mt-2">
      <b>{{ $t("essays.detectionSummary") }}</b>
      <ul>
        <li>
          {{ $t("essays.thereIsA") }}
          <b>{{ Math.round(flag.summary.aiUsageScore) }}%</b>
          {{ $t("essays.likelihoodWrittenWithAI") }}
        </li>
        <li>
          <b>{{ flag.summary.sentencesAffected }}</b>
          {{ $t("essays.aiDetector.percentSentencesShowSigns") }}
        </li>
      </ul>
    </div>
    <div class="mt-2">
      <eg-additional-collapse :label="$t('essays.showAiSentences')">
        <ul>
          <li v-for="(sentence, index) in flag.sentences" :key="index">
            {{ sentence }}
          </li>
        </ul>
      </eg-additional-collapse>
    </div>
  </div>
</template>

<script>
import EgAdditionalCollapse from "@/components/global/eg_additional_collapse.vue";

export default {
  components: {
    EgAdditionalCollapse,
  },

  props: {
    flag: {
      type: Object,
      required: true,
    },
  },
};
</script>
